<template>
  <div class="custom-video-box">
    <video
      :src="videoUrl"
      class="custom-video-box_video"
      controls
      playsinline
      :ref="videoRef"
      controlsList="nodownload"
    />
    <video
      v-if="showPosterVideo"
      :src="posterVideoUrl"
      preload="auto"
      muted
      autoplay
      loop
      class="custom-video-box_poster custom-video-box_video"
    />
    <!-- 遮罩层 -->
    <div class="custom-video-box_mask" v-if="showPosterVideo">
      <div class="custom-video-box_mask-bg"></div>
      <div class="custom-video-box_mask-title">{{ txtInfo.title }}</div>
      <div
        class="custom-video-box_mask-title custom-video-box_mask-subtitle"
        v-if="txtInfo.subTitle"
      >
        {{ txtInfo.subTitle }}
      </div>
      <div class="custom-video-box_mask-descr">{{ txtInfo.descr }}</div>
      <img
        class="custom-video-box_mask-btn"
        :src="
          currentLocale === 'zh'
            ? require('@/assets/img/pc/play-video.png')
            : require('@/assets/img/pc/watch-video.png')
        "
        @click="playVideo()"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    posterVideoUrl: {
      type: String,
      default: '',
    },
    videoUrl: {
      type: String,
      default: '',
    },
    txtInfo: {
      type: Object,
      default: '',
    },
  },
  data() {
    return {
      index: 0,
      videoRef: null,
      showPosterVideo: true,
    };
  },
  created() {
    this.index++;
    this.videoRef = 'videoPlayer' + this.index;
  },
  watch: {
    txtInfo(newVal, oldVal) {
      console.log('txtInfo change', this.txtInfo);
    },
  },
  methods: {
    playVideo() {
      this.$refs[this.videoRef].play();
      this.showPosterVideo = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-video-box {
  position: relative;
  height: 100%;
  border-radius: 20px;
  .custom-video-box_video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px;
  }
  .custom-video-box_poster {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .custom-video-box_mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    border-radius: 20px;
    overflow: hidden; /* 防止溢出 */
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .custom-video-box_mask-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: -1;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4); /* 半透明层 */
    }
    .custom-video-box_mask-title {
      //   font-weight: 500;
      font-family: 'MiSans-Medium';
      font-size: 50px;
      line-height: 66px;
    }
    .custom-video-box_mask-subtitle {
    }
    .custom-video-box_mask-descr {
      font-size: 18px;
      line-height: 32px;
      padding: 0 306px;
      margin-top: 10px;
    }
    .custom-video-box_mask-btn {
      width: 151px;
      height: 46px;
      margin-top: 120px;
      cursor: pointer;
      transition: all 0.3s ease;
      &:hover {
        transform: translateY(-8px) !important;
      }
    }
  }
}
</style>
